<template>
    <div>
        <!-- Breadcrumb Start-->
        <div class="section-breadcrumb">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 justify-content-center align-self-center pb-2">
                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                            <li class="text-white"><a href="#">Home</a></li>
                            <li class="text-white active">About Us</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- Breadcrumb End -->
        <!-- We are MedPill Section Start-->
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="mb-3 wow fadeInUp" data-wow-duration="1.5s">
                            <h1 class="font-weight-bold section-h1">
                                Medical Excellence,Compassionate Care
                            </h1>
                            <p class="text-left">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque rutrum pellentesque imperdiet. Nulla lacinia iaculis nulla non pulvinar. Sociis natoque penatibus et magnis dis parturient montes.
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque rutrum pellentesque imperdiet. Nulla lacinia iaculis nulla non pulvinar. Sociis natoque penatibus et magnis dis parturient montes.
                            </p>
                            <hr class="hr-border">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 wow fadeInUp" data-wow-duration="1.5s">
                        <h4 class="text-left font-weight-bold">Our Mission</h4>
                        <p class="text-left">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce elementum, nulla vel pellentesque consequat, ante nulla hendrerit arcu.</p>
                    </div>
                    <div class="col-md-4 wow fadeInUp" data-wow-duration="1.5s">
                        <h4 class="text-left font-weight-bold">Our Vision</h4>
                        <p class="text-left">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce nulla vel pellentesque consequat, ante nulla hendrerit arcu.</p>
                    </div>
                    <div class="col-md-4 wow fadeInUp" data-wow-duration="1.5s">
                        <h4 class="text-left font-weight-bold">Why Us</h4>
                        <p class="text-left">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce elementum, nulla vel consequat, ante nulla hendrerit arcu.</p>
                    </div>
                </div>
            </div>
        </section>
        <!-- We are MedPill Section End-->
        <!-- Who we are Section Start -->
        <section class="section bg-light">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <img src="assets/images/about/who-we-are.jpg" class="img-fluid" alt="">
                    </div>
                    <div class="col-md-6">
                        <h2 class="mt-30 text-left font-weight-bold">Who We Are</h2>
                        <p class="text-left">Lorem ipsum dolor sit amet, consectetur adipiscing elit massa enim. Nullam id varius nunc.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus blandit massa enim. Nullam id varius nunc. Vivamus bibendum magna ex, et faucibus lacus venenatis eget</p>
                        <p class="text-left">Lorem ipsum dolor sit amet, consectetur adipiscing elit massa enim. Nullam id varius nunc.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus blandit massa enim. Nullam id varius nunc. Vivamus bibendum magna ex, et faucibus lacus venenatis eget</p>
                    </div>
                </div>
            </div>
        </section>
        <!-- Who we are Section End -->
        <!-- Start Testimonial -->
        <section class="section bg-gradient">
            <div id="particles-js1">
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 wow fadeIn" data-wow-duration="1.5s">
                        <div class="section-title text-center mb-4">
                            <h2 class="text-white font-weight-bold">What People Say</h2>
                            <p class="text-white section_subtitle mx-auto">Lorem ipsum dolor sit amet, consectetur adipisicing elit. </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 wow fadeIn" data-wow-duration="1.5s">
                        <div class="owl-carousel owl-theme testimonial-slider wow fadeIn" data-wow-duration="1000ms">
                            <div class="item">
                                <div class="testimonial-card shadow-md">
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour,</p>
                                </div>
                                <div class="user-txt">
                                    <div class="user-pics"><img src="assets/images/testi/testi-1.png" alt=""></div>
                                    <div class="use-info">
                                        <h6 class="heading text-white">Jack Jordan</h6>
                                        <p class="sub-heading text-white">Mediapp User</p>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="testimonial-card shadow-md">
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour,</p>
                                </div>
                                <div class="user-txt">
                                    <div class="user-pics"><img src="assets/images/testi/testi-1.png" alt=""></div>
                                    <div class="user-info">
                                        <h6 class="heading text-white">Jack Jordan</h6>
                                        <p class="sub-heading text-white">Mediapp User</p>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="testimonial-card shadow-md">
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour,</p>
                                </div>
                                <div class="user-txt">
                                    <div class="user-pics"><img src="assets/images/testi/testi-1.png" alt=""></div>
                                    <div class="user-info">
                                        <h6 class="heading text-white">Jack Jordan</h6>
                                        <p class="sub-heading text-white">Mediapp User</p>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="testimonial-card shadow-md">
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour,</p>
                                </div>
                                <div class="user-txt">
                                    <div class="user-pics"><img src="assets/images/testi/testi-1.png" alt=""></div>
                                    <div class="user-info">
                                        <h6 class="heading text-white">Jack Jordan</h6>
                                        <p class="sub-heading text-white">Mediapp User</p>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="testimonial-card shadow-md">
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour,</p>
                                </div>
                                <div class="user-txt">
                                    <div class="user-pics"><img src="assets/images/testi/testi-1.png" alt=""></div>
                                    <div class="user-info">
                                        <h6 class="heading text-white">Jack Jordan</h6>
                                        <p class="sub-heading text-white">Mediapp User</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Testimonial End-->
        <!-- Client Section Start-->
        <section class="section client-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="owl-carousel owl-theme clients-slider wow fadeIn" data-wow-duration="1000ms">
                            <div class="item mr-2">
                                <img class="img-fluid" src="assets/images/clients/team-1.jpg" alt="">
                                <h5 class="mt-2 text-uppercase text-left font-weight-bold">John D. Tom</h5>
                                <p class="text-uppercase text-left">Laryngological Clinic</p>
                            </div>
                            <div class="item mr-2">
                                <img class="img-fluid" src="assets/images/clients/team-2.jpg" alt="">
                                <h5 class="mt-2 text-uppercase text-left font-weight-bold">Clare Mitchell</h5>
                                <p class="text-uppercase text-left">Pediatric</p>
                            </div>
                            <div class="item mr-2">
                                <img class="img-fluid" src="assets/images/clients/team-3.jpg" alt="">
                                <h5 class="mt-2 text-uppercase text-left font-weight-bold">Earlene Milone</h5>
                                <p class="text-uppercase text-left">Outpatient Surgery</p>
                            </div>
                            <div class="item mr-2">
                                <img class="img-fluid" src="assets/images/clients/team-4.jpg" alt="">
                                <h5 class="mt-2 text-uppercase text-left font-weight-bold">Norma Blueman</h5>
                                <p class="text-uppercase text-left">Dental Clinic</p>
                            </div>
                            <div class="item mr-2">
                                <img class="img-fluid" src="assets/images/clients/team-5.jpg" alt="">
                                <h5 class="mt-2 text-uppercase text-left font-weight-bold">Greta Midler</h5>
                                <p class="text-uppercase text-left">Management</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="wow fadeIn" data-wow-duration="1000ms">
                            <h2 class="mt-30 font-weight-bold">Meet Our Team</h2>
                            <p class="text-left">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus blandit massa enim. Nullam id varius nunc. Vivamus bibendum magna ex, et faucibus lacus venenatis eget.
                            </p>
                            <p class="text-left">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit massa enim. Nullam id varius nunc.
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus blandit massa enim. Nullam id varius nunc. Vivamus bibendum magna ex, et faucibus lacus venenatis eget.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>
<script>
    export default {
        name: "about",
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.hidePreloader();
                this.initSlider();
            },

            /*----PRELOADER-----*/
            hidePreloader() {
                var preloaderFadeOutTime = 500;
                var preloader = $('.spinner-wrapper');
                setTimeout(function () {
                    preloader.fadeOut(preloaderFadeOutTime);
                }, 500);
            },
            /*----SLIDER-----*/
            initSlider() {
              
                /*----TESTIMONIAL SLIDER-----*/
                var testimonialCarousel = $('.testimonial-slider');
                if (testimonialCarousel.length > 0) {
                    testimonialCarousel.owlCarousel({
                        margin: 16,
                        loop: true,
                        nav: false,
                        center: false,
                        dots: true,
                        autoplay: true,
                        autoplayTimeout: 5000,
                        items: 3,
                        responsiveClass: true,
                        responsive: {
                            0: {
                                items: 1,
                                nav: false,
                                dots: true
                            },
                            600: {
                                items: 2,
                                nav: false,
                                dots: true
                            },
                            1000: {
                                items: 3,
                                nav: false,
                                dots: true
                            }
                        }
                    });
                }
                /*----CLIENTS SLIDER-----*/
                (function ($) {
                    var testimonialCarousel = $('.clients-slider');
                    if (testimonialCarousel.length > 0) {
                        testimonialCarousel.owlCarousel({
                            margin: 16,
                            loop: true,
                            nav: true,
                            center: false,
                            dots: false,
                            autoplay: false,
                            autoplayTimeout: 5000,
                            items: 2,
                            responsiveClass: true,
                            responsive: {
                                0: {
                                    items: 1,
                                    nav: true,
                                    dots: false
                                },
                                600: {
                                    items: 2,
                                    nav: true,
                                    dots: false
                                },
                                1000: {
                                    items: 2,
                                    nav: true,
                                    dots: false
                                }
                            }
                        });
                    }
                })(jQuery);
            },

        }
    }</script>
